import { Component, Input, Output, EventEmitter } from '@angular/core';
import { forEach } from '../../../../../node_modules/@angular/router/src/utils/collection';

@Component({
  selector: 'alg-face-group',
  templateUrl: './alg-face-group.component.html',
  styleUrls: ['./alg-face-group.component.scss']
})
export class AlgFaceGroupComponent {
  @Input() faces: [{value: '', image: ''}];
  @Input() value: any;
  @Output() valueChange = new EventEmitter();

  constructor() { }

  imageSelected(value) {
    this.valueChange.emit(value);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/molecules/alg-face-group/alg-face-group.component.ts